// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';
import { Card } from '../../styled-components/dark/common';
import { columnGap } from '../../styled-components/dark/helpers';
import palette from '../../styled-components/palette';

const colGap = columnGap(0.6);

const Wrapper = styled.div`
  width: 100%;
  background-color: ${Target.__MOBILE__ ? palette.black : theme.Breadcrumbs.backgroundColor};
  display: flex;
  align-items: center;
  padding: 0.33em 1em;
  margin: 0.3em 0;
  border-radius: ${Card.borderRadius};

  ${colGap}
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.3em;

  &:last-child {
    margin-right: 0;
  }

  & svg {
    color: ${theme.Breadcrumbs.svgColor};
    height: 2em;
    width: 2em;
  }
`;

const Label = styled.div`
  font-weight: bold;
  font-size: 1.3em;
  color: ${theme.Breadcrumbs.color};
  line-height: 1em;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const IconButtonWrapper = styled.div`
  display: flex;
  padding: 0 0.3em;

  &:last-child {
    padding-right: 0;
  }
`;

type BreadcrumbsProps = {
  label: string;
  icons?: Array<unknown>;
  options?: Array<unknown>;
};

const Breadcrumbs = ({ label, icons = [], options = [] }: BreadcrumbsProps) => {
  return (
    <Wrapper>
      {icons.length ? (
        <Icons>
          {icons.map((icon, key) => (
            <IconWrapper key={`breadcrumbs-icon-${key}`}>{icon}</IconWrapper>
          ))}
        </Icons>
      ) : null}
      <Label>{label}</Label>
      {options.length ? (
        <OptionWrapper>
          {options.map((option, key) => (
            <IconButtonWrapper key={`breadcrumbs-icon-button-${key}`}>{option}</IconButtonWrapper>
          ))}
        </OptionWrapper>
      ) : null}
    </Wrapper>
  );
};

export default React.memo<BreadcrumbsProps>(Breadcrumbs);
